<div *ngIf="isLoading" nz-row class="cards-container">
  <nz-col
    *ngFor="let i of pageSizeArray"
    [nzXs]="isKanban ? 24 : 24"
    [nzSm]="isKanban ? 24 : 24"
    [nzMd]="isKanban ? 24 : 12"
    [nzLg]="isKanban ? 24 : 8"
    [nzXl]="isKanban ? 24 : 6"
  >
    <nz-card-loading> </nz-card-loading>
  </nz-col>
</div>
<ng-container *ngIf="!isLoading">
  <nz-empty
    nzNotFoundImage="simple"
    *ngIf="
      !isLoading &&
      listOfRecords.table.rowsArray != null &&
      listOfRecords.table.rowsArray.length === 0
    "
  >
  </nz-empty>
  <div nz-row class="cards-container">
    <nz-col
      *ngFor="let data of listOfRecords.table.rowsArray"
      [nzXs]="isKanban ? 24 : 24"
      [nzSm]="isKanban ? 24 : 24"
      [nzMd]="isKanban ? 24 : 12"
      [nzLg]="isKanban ? 24 : 8"
      [nzXl]="isKanban ? 24 : 6"
    >
      <nz-card
      [class]="(data['RowCustomClass'] != null && data['RowCustomClass'] !== undefined ? data['RowCustomClass'] : '')"
        nzHoverable
        [ngClass]="{
          'card-selected': inModuleList
            ? selectedRecordsFromCheckBox.indexOf(data[this.keyName]) != -1
            : selectedRecords.indexOf(data[this.keyName].toString()) != -1
            , 'card-not-selectable': !(data['U_ITM_ACTIVE'] == null || data['U_ITM_ACTIVE'] === undefined || data['U_ITM_ACTIVE'] === 'true')
        }"
        [nzExtra]="
          inModuleList && selectedRecordsFromCheckBox.length === 0
            ? actionTemplate
            : null
        "
        [nzTitle]="
          inModuleList && showCheckBoxInTableMode ? titleTemplate : null
        "
        [nzActions]="isEditable && isEditAuthorized ? [actionEdit] : ''"
      >
        <div class="selected-flag">
          <i nz-icon nzType="check" nzTheme="outline"></i>
        </div>
        <div
          style="display: block; width: 100%; position: relative"
          [innerHtml]="getRecordHtml(data) | safeHtml"
          (click)="selectCard(data)"
        ></div>
      </nz-card>
      <ng-template #titleTemplate>
        <label
          nz-checkbox
          (ngModelChange)="rowSelectedFromCheckBox(data, $event)"
          [ngModel]="
            inModuleList
              ? selectedRecordsFromCheckBox.indexOf(data[this.keyName]) != -1
              : selectedRecords.indexOf(data[this.keyName].toString()) != -1
          "
        >
        </label>
      </ng-template>
      <ng-template #actionTemplate>
        <div style="width: 50px; text-align: right; padding-right: 7px">
          <app-actions
            [isTokenized]="false"
            [moduleId]="moduleStructure.module.Id"
            [actionType]="'Edit'"
            [recordId]="data[this.keyName].toString()"
            [moduleInformation]="moduleInformation"
            [moduleStructure]="moduleStructure"
            [actions]="moduleActions"
            [inList]="true"
            [inModuleList]="inModuleList"
            [displayMode]="'cards'"
            [fromDraft]="fromDraft"
          >
          </app-actions>
        </div>
      </ng-template>
      <ng-template #actionEdit>
        <i nz-icon nzType="edit" (click)="editRecord(data[this.keyName])"></i>
      </ng-template>
    </nz-col>
  </div>
</ng-container>
